import { environmentManager } from '@tanstack/react-query';
import DOMPurify from 'dompurify';
import { type FC, type HTMLAttributes, memo, useEffect, useState } from 'react';

type Props = HTMLAttributes<HTMLDivElement> & {
  html: string | undefined;
};

if (!environmentManager.isServer()) {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName.toUpperCase() === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

const RawHtml: FC<Props> = memo(({ html, ...divProps }) => {
  const [text, setText] = useState('');

  useEffect(() => {
    setText(html ? DOMPurify.sanitize(html) : '');
  }, [html]);

  return <div {...divProps} dangerouslySetInnerHTML={{ __html: text }} />;
});

export default RawHtml;
